import { useObserver } from "mobx-react";
import { useEffect, useState } from "react";
import { useStores } from "../../store";
import ReportOverview from "./ReportOverview";
import Loader from "../reusble_components/loader";
import HelpCenter from "../reusble_components/helpCenter";
import PdfViewer from "../reusble_components/pdfViewer";

export default function MobileReportOverview({ enable = true }) {
  const { RecuiterStore, CommonStore } = useStores();
  const [loading, setLoading] = useState(true);

  const convertTimestampToDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);

    // Function to get the month name
    const getMonthName = (monthIndex) => {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];
      return months[monthIndex];
    };

    // Format the date to 'Month day, year' format
    const formattedDate = `${getMonthName(
      date.getMonth(),
    )} ${date.getDate()}, ${date.getFullYear()}`;

    return formattedDate;
  };

  useEffect(() => {
    const fetch = async () => {
      const applicantId = localStorage.getItem("applicantId");
      RecuiterStore.setJobPostApplicant(null);
      await RecuiterStore.fetchApplicantDetails(applicantId);
      setLoading(false);
    };

    fetch();
  }, []);

  const avgScore = (x, y) => {
    if (x && y) {
      return (x + y) / 2;
    } else {
      return;
    }
  };

  const userOrInterviewee =
    RecuiterStore.jobPostApplicant?.userId ||
    RecuiterStore.jobPostApplicant?.interviewee ||
    {};

  const candidate = {
    _id: userOrInterviewee?._id,
    name:
      userOrInterviewee?.name || RecuiterStore.jobPostApplicant?.name || "-",
    jobPost: RecuiterStore.jobPostApplicant?.jobPostId,
    mobile: userOrInterviewee?.mobile || "-",
    resumeScore: RecuiterStore.jobPostApplicant?.resumeScore,
    labels: RecuiterStore.jobApplications.labels ?? [],
    resume: RecuiterStore.jobPostApplicant?.resume,
    proxyId:
      RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId?._id ||
      RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?._id ||
      RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?._id ||
      "",
    proxy: {
      isOverallProxy:
        RecuiterStore.jobPostApplicant?.technicalInterview?.customSettings?.find(
          (setting) => setting.name === "proxy" && setting.value === true,
        ) ||
        RecuiterStore.jobPostApplicant?.hrInterview?.customSettings?.find(
          (setting) => setting.name === "proxy" && setting.value === true,
        ) ||
        RecuiterStore.jobPostApplicant?.codingInterview?.customSettings?.find(
          (setting) => setting.name === "proxy" && setting.value === true,
        )
          ? true
          : false,
      // isOverallProxy: true,
      interviewId:
        RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
          ?.interviewId ||
        RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.interviewId ||
        RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?.interviewId ||
        "",
      proxyId:
        RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId?._id ||
        RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?._id ||
        RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?._id ||
        "",
      technicalInterviewProxyId:
        RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId,
      hrInterviewProxyId: RecuiterStore.jobPostApplicant?.hrInterview?.proxyId,
      codingInterviewProxyId:
        RecuiterStore.jobPostApplicant?.codingInterview?.proxyId,
      tabChanges:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.tabChanges?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.tabChanges
            ?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?.tabChanges
            ?.count || 0,
        ),
      faceOutOfView:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.faceOutOfView?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.faceOutOfView
            ?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId
            ?.faceOutOfView?.count || 0,
        ),
      multipleFacesDetected:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.multipleFacesDetected?.count - 1 || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId
            ?.multipleFacesDetected?.count - 1 || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId
            ?.multipleFacesDetected?.count - 1 || 0,
        ),
      textDetection:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.textDetection?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.textDetection
            ?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId
            ?.textDetection?.count || 0,
        ),
      multipleVoicesDetected:
        Number(
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
            ?.multipleVoicesDetected?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId
            ?.multipleVoicesDetected?.count || 0,
        ) +
        Number(
          RecuiterStore.jobPostApplicant?.codingInterview?.proxyId
            ?.multipleVoicesDetected?.count || 0,
        ),
    },
    mcq: RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
      ?.accuracy,
    date:
      convertTimestampToDate(RecuiterStore.jobPostApplicant?.createdAt) ?? "-",
    location: userOrInterviewee?.city || "-",
    email: userOrInterviewee?.mail || "-",
    jobRole: RecuiterStore.jobPostApplicant?.jobPostId?.jobTitle ?? "-",
    results:
      RecuiterStore.jobPostApplicant?.hrInterview?.result ??
      RecuiterStore.jobPostApplicant?.technicalInterview?.result ??
      "Pending",
    technicalSkills:
      RecuiterStore.jobPostApplicant?.technicalInterview?.result[1]?.score ??
      RecuiterStore.jobPostApplicant?.hrInterview?.result[1]?.score ??
      "Pending",
    communication:
      avgScore(
        RecuiterStore.jobPostApplicant?.technicalInterview?.result[2]?.score,
        RecuiterStore.jobPostApplicant?.hrInterview?.result[2]?.score,
      ) ??
      RecuiterStore.jobPostApplicant?.technicalInterview?.result[2]?.score ??
      RecuiterStore.jobPostApplicant?.hrInterview?.result[2]?.score ??
      "Pending",
    overallScore:
      RecuiterStore.jobPostApplicant?.technicalInterview?.result[0]?.score ??
      RecuiterStore.jobPostApplicant?.hrInterview?.result[0]?.score ??
      RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
        ?.accuracy ??
      "Pending",
    resumelink: RecuiterStore.jobPostApplicant?.technicalInterview?.resumeLink,
    id: RecuiterStore.jobPostApplicant?._id,
    mcq: {
      score: RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
        ?.overall
        ? RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
            ?.accuracy
        : "Pending",
      status: RecuiterStore.jobPostApplicant?.mockTest ? true : false,
    },
    hr: {
      score: RecuiterStore.jobPostApplicant?.hrInterview
        ? RecuiterStore.jobPostApplicant?.hrInterview?.isResultPublished
          ? RecuiterStore.jobPostApplicant?.hrInterview?.result[0]?.score
          : "No result"
        : "Pending",
      status: RecuiterStore.jobPostApplicant?.hrInterview ? true : false,
    },
    preScreeningAnswers: RecuiterStore.jobPostApplicant?.preScreeningAnswers,
    assessment: {
      show: RecuiterStore.jobPostApplicant?.jobPostId?.assessment
        ? true
        : false,
      isCompleted:
        RecuiterStore.jobPostApplicant?.assessment?.isAssessmentCompleted,
      assessmentData: RecuiterStore.jobPostApplicant?.jobPostId?.assessment,
      result: RecuiterStore.jobPostApplicant?.assessment ?? null,
    },
    applicationEvaluation: RecuiterStore.jobPostApplicant?.applicantEvaluation,
    skills: userOrInterviewee?.skills,
    technical: {
      score: RecuiterStore.jobPostApplicant?.technicalInterview
        ? RecuiterStore.jobPostApplicant?.technicalInterview?.isResultPublished
          ? RecuiterStore.jobPostApplicant?.technicalInterview?.result[0]?.score
          : "No result"
        : "Pending",
      status: RecuiterStore.jobPostApplicant?.technicalInterview ? true : false,
    },
    image: userOrInterviewee?.pic, // Replace with the actual image URL
    isShortlisted: RecuiterStore.jobPostApplicant?.isShortlisted ?? false,
    isRejected: RecuiterStore.jobPostApplicant?.isRejected ?? false,
    createdAt: RecuiterStore.jobPostApplicant?.createdAt,
    status: RecuiterStore.jobPostApplicant?.status,
    resumeCutoffScore:
      RecuiterStore.jobPostApplicant?.jobPostId?.resumeCutoffScore,
    resumeScore: RecuiterStore.jobPostApplicant?.resumeScore,
    interviewFeedback: RecuiterStore.jobPostApplicant?.interviewFeedback,
  };
  // CommonStore.setJobResume(RecuiterStore.jobPostApplicant?.resume);
  const salarySuggetionTemp = RecuiterStore.jobPostApplicant
    ?.salarySuggestionTemp
    ? JSON.parse(RecuiterStore.jobPostApplicant?.salarySuggestionTemp)
    : {};

  const getTheResultByTopic = ({ topic, interviewData }) => {
    if (interviewData === null) return "";
    const result = interviewData?.result?.filter((q) => q?.name === topic);

    return result ? result[0]?.score : "";
  };

  const getTheResultByTopic1 = ({ topic, interviewData }) => {
    if (interviewData === null) return "";
    const result = interviewData?.result?.filter((q) => q?.name === topic);

    return result ? result[0]?.positives : "";
  };

  const getTheResultByTopic2 = ({ topic, interviewData }) => {
    if (interviewData === null) return "";
    const result = interviewData?.result?.filter((q) => q?.name === topic);

    return result ? result[0]?.negatives : "";
  };

  // const checkInterviewCompletionStatus = (interview) => {
  //   const questions =
  //     (interview?.noOfQuestions + interview?.customQuestions.length) * 2;
  //   const messages = interview?.messages.length;
  //   if (questions - 2 <= messages) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };
  // const getTheResultByTopic = ({ topic, interviewData }) => {
  //   if (interviewData === null) return "";
  //   const result = interviewData?.result?.filter((q) => q?.name === topic);

  //   return result ? result[0]?.score : "";
  // };

  const checkInterviewCompletionStatus = (interview) => {
    const questions =
      (interview?.noOfQuestions + interview?.customQuestions.length) * 2;
    const messages = interview?.messages.length;
    if (questions - 2 <= messages) {
      return true;
    } else {
      return false;
    }
  };

  const recruiter = {
    ...RecuiterStore.jobPostApplicant?.recruiter,
  };

  const formatSalary = (salary) => {
    if (salary >= 10000000) {
      return (salary / 10000000).toFixed(2) + " Cr";
    } else if (salary >= 100000) {
      return (salary / 100000).toFixed(2) + " L";
    } else if (salary >= 1000) {
      return (salary / 1000).toFixed(2) + " K";
    } else {
      return salary;
    }
  };

  const proxy = RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId;

  const reportData = [
    {
      title: "Salary Recommendation System",
      show: RecuiterStore.jobPostApplicant?.isSalarySuggestionGenerated,
      video: false,
      videoData: null,
      details: [
        {
          label: "Proposed Salary :",
          value: formatSalary(salarySuggetionTemp?.proposedSalary),
        },
        {
          label: "Expected Salary :",
          value: formatSalary(salarySuggetionTemp?.expectedSalary),
        },
        {
          label: "Recommended Salary :",
          value: `${formatSalary(
            salarySuggetionTemp?.recommendedSalaryLow,
          )} - ${formatSalary(salarySuggetionTemp?.recommendedSalaryHigh)}`,
        },
      ],
      salarySuggetionTemp: salarySuggetionTemp ?? null,
    },
    {
      title: "MCQ Test Report",
      video: true,
      show: RecuiterStore.jobPostApplicant?.jobPostId?.mockTest ? true : false,
      mcq: true,
      score:
        RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
          ?.accuracy ?? null,
      isCompleted:
        RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.overall
          ?.accuracy ?? null,
      videoData: null,
      candidate: candidate,
      recruiterId: recruiter?._id,
      date: convertTimestampToDate(
        RecuiterStore.jobPostApplicant?.mockTest?.createdAt,
      ),
      details: [
        {
          label: "Name:",
          value:
            RecuiterStore.jobPostApplicant?.jobPostId?.mockTest?.mockTestName,
        },
        {
          label: "Cut off :",
          value: RecuiterStore.jobPostApplicant?.mockTest?.cutOff
            ? RecuiterStore.jobPostApplicant?.mockTest?.cutOff
            : "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value:
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.overall?.correct +
            "/" +
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.overall?.total,
        },
        {
          label: "Status:",
          value: RecuiterStore.jobPostApplicant?.mockTest?.cutOff
            ? RecuiterStore.jobPostApplicant?.mockTest?.cutOff >
              RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
                ?.overall?.accuracy
              ? "Failed"
              : "Qualified"
            : RecuiterStore.jobPostApplicant?.mockTest?.isCompleted
              ? "Completed"
              : "Pending",
        },
        // {
        //   label: "Number of questions:",
        //   value:
        //     RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
        //       ?.overall?.correct +
        //     "/" +
        //     RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
        //       ?.overall?.total,
        // },
        {
          label: "Technical:",
          value: RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
            ? RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport[
                RecuiterStore.jobPostApplicant?.jobPostId?.mockTest
                  ?.mockTestName
              ]?.correct
            : "0" +
                "/" +
                RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ? RecuiterStore.jobPostApplicant?.mockTest?.mockTestName
              : "0",
        },
        {
          label: "Aptitude:",
          value:
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.Aptitude?.correct +
            "/" +
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.Aptitude?.total,
        },
        {
          label: "Reasoning:",
          value:
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.Reasoning?.correct +
            "/" +
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport
              ?.Reasoning?.total,
        },
        {
          label: "Verbal:",
          value:
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.Verbal
              ?.correct +
            "/" +
            RecuiterStore.jobPostApplicant?.mockTest?.categoryWiseReport?.Verbal
              ?.total,
        },
      ],
      showCheckDetails: RecuiterStore.jobPostApplicant?.mockTest ? true : false,
      reportId: RecuiterStore.jobPostApplicant?.mockTest?._id,
    },
    {
      title: "Technical Interview Report",
      show: RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview
        ? true
        : false,
      video: true,
      recruiterId: recruiter?._id,
      score:
        getTheResultByTopic({
          topic: "average_technical_score",
          interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
        }) ?? null,
      isCompleted:
        RecuiterStore.jobPostApplicant?.technicalInterview
          ?.isInterviewCompleted,
      videoData: {
        videoSrc:
          RecuiterStore.jobPostApplicant?.technicalInterview?.recording ?? "",
        onDownload: () => console.log("Downloading video 1"),
        title: "Technical Interview",
        image:
          RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId?.snapShots
            ?.length > 0
            ? RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId
                ?.snapShots[0]?.url
            : "",
      },
      candidate: candidate,
      date: convertTimestampToDate(
        RecuiterStore.jobPostApplicant?.technicalInterview?.createdAt,
      ),
      details: [
        {
          label: "Assesment Name:",
          value:
            RecuiterStore.jobPostApplicant?.technicalInterview?.interviewType,
        },
        // {
        //   label: "Level of interview:",
        //   value:
        //     RecuiterStore.jobPostApplicant?.technicalInterview
        //       ?.levelOfInterview,
        // },
        {
          label: "Cut off :",
          value: RecuiterStore.jobPostApplicant?.technicalInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.technicalInterview?.cutOff
            : "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value:
            RecuiterStore.jobPostApplicant?.technicalInterview?.noOfQuestions,
        },
        {
          label: "Status:",
          value: RecuiterStore.jobPostApplicant?.technicalInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.technicalInterview?.cutOff >
              getTheResultByTopic({
                topic: "average_technical_score",
                interviewData:
                  RecuiterStore.jobPostApplicant?.technicalInterview,
              })
              ? "Failed"
              : "Qualified"
            : RecuiterStore.jobPostApplicant?.technicalInterview
                  ?.isInterviewCompleted
              ? "Completed"
              : "Pending",
        },
      ],
      questions: RecuiterStore.jobPostApplicant?.technicalInterview?.questions,
      showCheckDetails: RecuiterStore.jobPostApplicant?.technicalInterview
        ? true
        : false,
      reportId: RecuiterStore.jobPostApplicant?.technicalInterview?._id,
      technical: true,
      interviewId:
        RecuiterStore.jobPostApplicant?.technicalInterview &&
        RecuiterStore.jobPostApplicant?.technicalInterview?.result?.length ===
          0 &&
        checkInterviewCompletionStatus(
          RecuiterStore.jobPostApplicant?.technicalInterview,
        )
          ? RecuiterStore.jobPostApplicant?.technicalInterview?._id
          : null,

      summerySuggestion: getTheResultByTopic({
        topic: "summerySuggestion",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      interviewSuggestion: getTheResultByTopic({
        topic: "interviewSuggestion",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      interviewEvaluation: getTheResultByTopic({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      positives: getTheResultByTopic1({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      negatives: getTheResultByTopic2({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      meetingId: RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview,
      proxyId: RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId?._id,
      applicantId: RecuiterStore.jobPostApplicant?._id,
    },
    {
      hr: true,
      title: "HR Interview Report",
      video: true,
      show: RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview
        ? true
        : false,
      score:
        getTheResultByTopic({
          topic: "average_technical_score",
          interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
        }) ?? null,
      isCompleted:
        RecuiterStore.jobPostApplicant?.hrInterview?.isInterviewCompleted,

      videoData: {
        videoSrc: RecuiterStore.jobPostApplicant?.hrInterview?.recording ?? "",
        onDownload: () => console.log("Downloading video 2"),
        title: "HR Interview",
        image:
          RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.snapShots
            ?.length > 0
            ? RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?.snapShots[0]
                ?.url
            : "",
      },
      proxyId: RecuiterStore.jobPostApplicant?.hrInterview?.proxyId?._id,
      candidate: candidate,
      date: convertTimestampToDate(
        RecuiterStore.jobPostApplicant?.hrInterview?.createdAt,
      ),

      details: [
        {
          label: "Interview name:",
          value: RecuiterStore.jobPostApplicant?.hrInterview?.technology,
        },
        // {
        //   label: "Score:",
        //   value: RecuiterStore.jobPostApplicant?.hrInterview?.result[0]?.score,
        // },
        {
          label: "Cut off :",
          value: RecuiterStore.jobPostApplicant?.hrInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.hrInterview?.cutOff
            : "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value:
            RecuiterStore.jobPostApplicant?.technicalInterview?.noOfQuestions,
        },
        {
          label: "Status:",
          value: RecuiterStore.jobPostApplicant?.hrInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.hrInterview?.cutOff >
              getTheResultByTopic({
                topic: "average_technical_score",
                interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
              })
              ? "Failed"
              : "Qualified"
            : RecuiterStore.jobPostApplicant?.hrInterview?.isInterviewCompleted
              ? "Completed"
              : "Pending",
        },
      ],
      questions: RecuiterStore.jobPostApplicant?.hrInterview?.questions,
      showCheckDetails: RecuiterStore.jobPostApplicant?.hrInterview
        ? true
        : false,
      reportId: RecuiterStore.jobPostApplicant?.hrInterview?._id,
      interviewId:
        RecuiterStore.jobPostApplicant?.hrInterview &&
        RecuiterStore.jobPostApplicant?.hrInterview?.result?.length === 0 &&
        checkInterviewCompletionStatus(
          RecuiterStore.jobPostApplicant?.hrInterview,
        )
          ? RecuiterStore.jobPostApplicant?.hrInterview?._id
          : null,
      summerySuggestion: getTheResultByTopic({
        topic: "summerySuggestion",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      recruiterId: recruiter?._id,
      meetingId: RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview,
      interviewSuggestion: getTheResultByTopic({
        topic: "interviewSuggestion",
        interviewData: RecuiterStore.jobPostApplicant?.technicalInterview,
      }),
      interviewEvaluation: getTheResultByTopic({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
      }),
      positives: getTheResultByTopic1({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
      }),
      negatives: getTheResultByTopic2({
        topic: "interviewEvaluation",
        interviewData: RecuiterStore.jobPostApplicant?.hrInterview,
      }),
      applicantId: RecuiterStore.jobPostApplicant?._id,
    },
    {
      title: "Coding Interview Report",
      show: RecuiterStore.jobPostApplicant?.jobPostId?.codingInterview
        ? true
        : false,
      video: true,
      recruiterId: recruiter?._id,
      videoData: null,
      score:
        RecuiterStore.jobPostApplicant?.codingInterview?.results[0]
          ?.percentage ?? null,
      isCompleted: RecuiterStore.jobPostApplicant?.codingInterview?.isCompleted,
      candidate: candidate,
      date: convertTimestampToDate(
        RecuiterStore.jobPostApplicant?.codingInterview?.createdAt,
      ),
      details: [
        {
          label: "Language:",
          value: RecuiterStore.jobPostApplicant?.codingInterview?.language,
        },
        // {
        //   label: "Level of interview:",
        //   value:
        //     RecuiterStore.jobPostApplicant?.technicalInterview
        //       ?.levelOfInterview,
        // },
        {
          label: "Cut off :",
          value: RecuiterStore.jobPostApplicant?.codingInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.codingInterview?.cutOff
            : "Not Mentioned",
        },
        {
          label: "Number of questions:",
          value: RecuiterStore.jobPostApplicant?.codingInterview?.noOfQuestions,
        },
        {
          label: "Status:",
          value: RecuiterStore.jobPostApplicant?.codingInterview?.cutOff
            ? RecuiterStore.jobPostApplicant?.codingInterview?.cutOff >
              getTheResultByTopic({
                topic: "average_technical_score",
                interviewData: RecuiterStore.jobPostApplicant?.codingInterview,
              })
              ? "Failed"
              : "Qualified"
            : RecuiterStore.jobPostApplicant?.codingInterview?.isCompleted
              ? "Completed"
              : "Pending",
        },
      ],
      questions: RecuiterStore.jobPostApplicant?.codingInterview?.questions,
      showCheckDetails: RecuiterStore.jobPostApplicant?.codingInterview
        ? true
        : false,
      reportId: RecuiterStore.jobPostApplicant?.codingInterview?._id,
      technical: true,
      interviewId:
        RecuiterStore.jobPostApplicant?.codingInterview &&
        RecuiterStore.jobPostApplicant?.codingInterview?.results?.length ===
          0 &&
        checkInterviewCompletionStatus(
          RecuiterStore.jobPostApplicant?.codingInterview,
        )
          ? RecuiterStore.jobPostApplicant?.codingInterview?._id
          : null,
      meetingId: RecuiterStore.jobPostApplicant?.jobPostId?.codingInterview,
      proxyId: RecuiterStore.jobPostApplicant?.codingInterview?.proxyId?._id,
      applicantId: RecuiterStore.jobPostApplicant?._id,
    },
  ];
  const videoData = [
    {
      videoSrc:
        RecuiterStore.jobPostApplicant?.technicalInterview?.recording ?? "",
      onDownload: () => console.log("Downloading video 1"),
      title: "Technical Interview",
    },
    {
      videoSrc: RecuiterStore.jobPostApplicant?.hrInterview?.recording ?? "",
      onDownload: () => console.log("Downloading video 2"),
      title: "HR Interview",
    },
    // {
    //   videoSrc: "https://reaidystorage.blob.core.windows.net/recordings/6655b855d50568b6d5ad7eb0.webm",
    //   onDownload: () => console.log("Downloading video 3"),
    //   title: "Test Interview",
    // },
  ];
  return useObserver(() => (
    <div className="w-full">
      {CommonStore.resume && (
        <PdfViewer
          pdfUrl={CommonStore.jobresume}
          onClose={() => CommonStore.setResume(false)}
        />
      )}
      <HelpCenter />
      <Loader loader={loading} />
      {!loading && (
        <ReportOverview
          candidate={candidate}
          reportData={reportData}
          videoData={videoData}
          proxy={proxy}
          enable={enable}
        />
      )}
    </div>
  ));
}
